import Index from "@/pages/Index";
import NotFound from "@/pages/NotFound";
import { coreRoutes } from "./lazyCore";
import { serviceRoutes } from "./lazyServices";
import { contentRoutes } from "./lazyContent";
import type { RouteDef } from "./shared";

export type { RouteDef };

export const routes: RouteDef[] = [
  // Canonical national service URLs (recommended architecture)
  ...serviceRoutes,
  // Legacy URL routes (kept for continuity)
  { path: "/", element: <Index /> },
  ...coreRoutes,
  // Industries + multi-state + business continuity + loans + insights
  ...contentRoutes,
  { path: "*", element: <NotFound /> },
];
